import { calendarResourceTypes } from '../calendarResourceTypes';
import { type AbstractCalendarResource } from './AbstractCalendarResource';
import { type CalendarExperteResource } from './CalendarExperteResource';
import { type CalendarGruppenraumResource } from './CalendarGruppenraumResource';
import { type CalendarSeminarraumResource } from './CalendarSeminarraumResource';
import { type CalendarStandortResource } from './CalendarStandortResource';

export const isExperteResource = (resourceData: AbstractCalendarResource): resourceData is CalendarExperteResource =>
  resourceData.type === calendarResourceTypes.EXPERTE;
export const isSeminarraumResource = (
  resourceData: AbstractCalendarResource,
): resourceData is CalendarSeminarraumResource => resourceData.type === calendarResourceTypes.SEMINARRAUM;
export const isGruppenraumResource = (
  resourceData: AbstractCalendarResource,
): resourceData is CalendarGruppenraumResource => resourceData.type === calendarResourceTypes.GRUPPENRAUM;
export const isStandortResource = (resourceData: AbstractCalendarResource): resourceData is CalendarStandortResource =>
  resourceData.type === calendarResourceTypes.STANDORT;
